export const KYC_CASE_STATUS = {
  open: "Open",
  declined: "Declined",
  approved: "Approved"
};
